import { LEDGER_ENTRY_TYPE } from 'Data/payments.js'

export function getTransactionsWithNotes(entry) {
  switch (entry.type) {
    case LEDGER_ENTRY_TYPE.CHARGE:
    case LEDGER_ENTRY_TYPE.ADJUSTMENT:
      return entry.transactions.filter(t => !!t.notes)
    case LEDGER_ENTRY_TYPE.PAYMENT:
      return entry.payment.notes ? [entry.payment] : []
    case LEDGER_ENTRY_TYPE.NOTE:
      return [entry.note]
    default:
      return entry.transaction.notes ? [entry.transaction] : []
  }
}
